import { render } from "./statute.vue?vue&type=template&id=5db28b3c&scoped=true"
import script from "./statute.vue?vue&type=script&lang=js"
export * from "./statute.vue?vue&type=script&lang=js"

import "./statute.vue?vue&type=style&index=0&id=5db28b3c&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\xinfu-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db28b3c"]])

export default __exports__